import React, { useCallback, useState } from "react";
import { useScrollY } from "../util/hooks";
import { Transition } from "@headlessui/react";
import { FeedbackDialog } from "./Dialog";
import { BsLink45Deg } from "react-icons/bs";
import { RxArrowUp } from "react-icons/rx";
import { useTranslations } from "next-intl";
interface FloatingIconButtonProps {
  icon: any;
  onClick?: () => void;
}

export const FloatingIconButton: React.FC<FloatingIconButtonProps> = ({
  icon,
  onClick,
}) => {
  return (
    <button
      className="aspect-square w-[50px] rounded-[5px] bg-cultured shadow-md hover:shadow-xl"
      onClick={onClick}
    >
      <div className="flex flex-row justify-center">{icon}</div>
    </button>
  );
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

interface ScrollToTopButtonProps {
  showBreakpoint: number;
}

export const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
  showBreakpoint,
}) => {
  const showButton = useScrollY() > showBreakpoint;
  return (
    <Transition
      show={showButton}
      enter="transition-opacity duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <FloatingIconButton
        icon={<RxArrowUp className="h-[28px] w-[28px] text-davys-gray" />}
        onClick={scrollToTop}
      />
    </Transition>
  );
};

interface ShareButtonProps {}

export const ShareButton: React.FC<ShareButtonProps> = () => {
  const [isOpen, setIsOpen] = useState(false);

  const copyWindowLocation = useCallback(async () => {
    await navigator.clipboard.writeText(window.location.href);
    setIsOpen(true);
  }, []);
  const t = useTranslations("News.linkModal");

  return (
    <>
      <FloatingIconButton
        icon={<BsLink45Deg className="h-[30px] w-[30px] text-davys-gray" />}
        onClick={copyWindowLocation}
      />
      <FeedbackDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t("title")}
        description={t("linkText")}
        buttonText={t("closeText")}
      />
    </>
  );
};
